import { NgModule } from '@angular/core';
import { Routes, RouterModule } from "@angular/router";
import { OrganizationComponent } from './organization/organization.component';
import { ElementsComponent } from './elements/elements.component';
import { ElementdetailsComponent } from './elementdetails/elementdetails.component';
import { MembersComponent } from './members/members.component';
import { ProjectsComponent } from './projects/projects.component';
import { TransmittalTemplateComponent } from './transmittal-template/transmittal-template.component';
import { ApplicationMenuComponent } from './application-menu/application-menu.component';
import { TenderQuantityComponent } from './tender-quantity/tender-quantity.component';


export const masterRoutes: Routes = [
    { path: 'organization', component: OrganizationComponent, data: { title: 'ORGANIZATION - Business Group', isProjectCodeRequired: false } },
    { path: 'elements', component: ElementsComponent, data: { title: 'ELEMENTS', isProjectCodeRequired: false } },
    { path: 'elementdetails', component: ElementdetailsComponent, data: { title: 'ELEMENT DETAILS', isProjectCodeRequired: false } },
    { path: 'externalmembers', component: MembersComponent, data: { title: 'MEMBERS', isProjectCodeRequired: false } },
    { path: 'projects', component: ProjectsComponent, data: { title: 'PROJECTS', isProjectCodeRequired: false } },
    { path: 'menu', component: ApplicationMenuComponent, data: { title: 'APPLICATION MENU', isProjectCodeRequired: false } },
    { path: 'transmittal-template', component: TransmittalTemplateComponent, data: { title: 'TRANSMITTAL TEMPLATE', isProjectCodeRequired: true } },
    { path: 'tenderquantity', component: TenderQuantityComponent, data: { title: 'TENDER QUANTITY', isProjectCodeRequired: false } },
   
];

@NgModule({
    imports: [RouterModule.forChild(masterRoutes)],
    exports: [RouterModule]
})

export class MasterRoutingModule { }
